"use strict";

var _classCallCheck = require("@babel/runtime/helpers/classCallCheck");

var _createClass = require("@babel/runtime/helpers/createClass");

var _inherits = require("@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WalletLinkSdkUI = void 0;

var WalletLinkUI_1 = require("./WalletLinkUI");

var cssReset_1 = require("../lib/cssReset");

var LinkFlow_1 = require("../components/LinkFlow");

var Snackbar_1 = require("../components/Snackbar");

var WalletLinkSdkUI = /*#__PURE__*/function (_WalletLinkUI_1$Walle) {
  _inherits(WalletLinkSdkUI, _WalletLinkUI_1$Walle);

  var _super = _createSuper(WalletLinkSdkUI);

  function WalletLinkSdkUI(options) {
    var _this;

    _classCallCheck(this, WalletLinkSdkUI);

    _this = _super.call(this, options);
    _this.attached = false;
    _this.snackbar = new Snackbar_1.Snackbar({
      darkMode: options.darkMode
    });
    _this.linkFlow = new LinkFlow_1.LinkFlow({
      darkMode: options.darkMode,
      version: options.version,
      sessionId: options.session.id,
      sessionSecret: options.session.secret,
      walletLinkUrl: options.walletLinkUrl,
      connected$: options.connected$,
      isParentConnection: false
    });
    return _this;
  }

  _createClass(WalletLinkSdkUI, [{
    key: "attach",
    value: function attach() {
      if (this.attached) {
        throw new Error("WalletLinkUI is already attached");
      }

      var el = document.documentElement;
      var container = document.createElement("div");
      container.className = "-walletlink-css-reset";
      el.appendChild(container);
      this.linkFlow.attach(container);
      this.snackbar.attach(container);
      this.attached = true;
      cssReset_1.injectCssReset();
    }
  }, {
    key: "setConnectDisabled",
    value: function setConnectDisabled(connectDisabled) {
      this.linkFlow.setConnectDisabled(connectDisabled);
    }
  }, {
    key: "requestEthereumAccounts",
    value: function requestEthereumAccounts(options) {
      this.linkFlow.open({
        onCancel: options.onCancel
      });
    }
  }, {
    key: "hideRequestEthereumAccounts",
    value: function hideRequestEthereumAccounts() {
      this.linkFlow.close();
    }
  }, {
    key: "showConnecting",
    value: function showConnecting(options) {
      var snackbarProps = {
        message: "Confirm on phone",
        menuItems: [{
          isRed: true,
          info: "Cancel transaction",
          svgWidth: "11",
          svgHeight: "11",
          path: "M10.3711 1.52346L9.21775 0.370117L5.37109 4.21022L1.52444 0.370117L0.371094 1.52346L4.2112 5.37012L0.371094 9.21677L1.52444 10.3701L5.37109 6.53001L9.21775 10.3701L10.3711 9.21677L6.53099 5.37012L10.3711 1.52346Z",
          defaultFillRule: "inherit",
          defaultClipRule: "inherit",
          onClick: options.onCancel
        }, {
          isRed: false,
          info: "Reset connection",
          svgWidth: "10",
          svgHeight: "11",
          path: "M5.00008 0.96875C6.73133 0.96875 8.23758 1.94375 9.00008 3.375L10.0001 2.375V5.5H9.53133H7.96883H6.87508L7.80633 4.56875C7.41258 3.3875 6.31258 2.53125 5.00008 2.53125C3.76258 2.53125 2.70633 3.2875 2.25633 4.36875L0.812576 3.76875C1.50008 2.125 3.11258 0.96875 5.00008 0.96875ZM2.19375 6.43125C2.5875 7.6125 3.6875 8.46875 5 8.46875C6.2375 8.46875 7.29375 7.7125 7.74375 6.63125L9.1875 7.23125C8.5 8.875 6.8875 10.0312 5 10.0312C3.26875 10.0312 1.7625 9.05625 1 7.625L0 8.625V5.5H0.46875H2.03125H3.125L2.19375 6.43125Z",
          defaultFillRule: "evenodd",
          defaultClipRule: "evenodd",
          onClick: options.onResetConnection
        }]
      };
      return this.snackbar.presentItem(snackbarProps);
    }
  }, {
    key: "reloadUI",
    value: function reloadUI() {
      document.location.reload();
    }
  }, {
    key: "inlineAccountsResponse",
    value: function inlineAccountsResponse() {
      return false;
    }
  }]);

  return WalletLinkSdkUI;
}(WalletLinkUI_1.WalletLinkUI);

exports.WalletLinkSdkUI = WalletLinkSdkUI;